export const commands = [
  {
    name: 'Overview',
    group: 'Pages',
    type: 'link',
    to: '/app',
  },
  {
    name: 'Administration',
    group: 'Pages',
    type: 'link',
    to: '/app/administration',
  },
  {
    name: 'Finance',
    group: 'Pages',
    type: 'link',
    to: '/app/finance',
  },
  {
    name: 'Users',
    group: 'Pages',
    type: 'link',
    to: '/app/users',
  },
  {
    name: 'Transactions',
    group: 'Pages',
    type: 'link',
    to: '/app/transactions',
  },
  {
    name: 'KYC',
    group: 'Pages',
    type: 'link',
    to: '/app/kyc',
  },
  {
    name: 'Help Center',
    group: 'Support',
    type: 'external',
    href: 'https://help.wire24.co',
  },
//   {
//     name: 'Log Out',
//     group: 'Actions',
//     type: 'action',
//     onClick: () => {
//       console.log('Logging out...');
//     },
//   },
];
